import axios from 'axios';
import * as actionTypes from './actionTypes';

export const ticketsLoading = () => {
    return {
        type: actionTypes.TICKETS_LOADING
    }
};

export const ticketsFail = (error) => {
    return {
        type: actionTypes.TICKETS_FAIL,
        error: error
    }
};

export const ticketsSuccess = (data) => {
    return {
        type: actionTypes.TICKETS_SUCCESS,
        payload: data
    }
};

export const addTicketInitialize = () => {
    return {
        type: actionTypes.ADD_TICKET_INITIALIZE
    }
};

export const addTicketLoading = () => {
    return {
        type: actionTypes.ADD_TICKET_LOADING
    }
};

export const addTicketFail = (error) => {
    return {
        type: actionTypes.ADD_TICKET_FAIL,
        error: error
    }
};

export const addTicketSuccess = (data) => {
    return {
        type: actionTypes.ADD_TICKET_SUCCESS,
        payload: data
    }
};

export const initializeAddTicket = () => {
    return dispatch => {
        dispatch(addTicketInitialize());
    }
};

export const getTicketInitialize = () => {
    return {
        type: actionTypes.GET_TICKET_INITIALIZE
    }
};

export const getTicketLoading = () => {
    return {
        type: actionTypes.GET_TICKET_LOADING
    }
};

export const getTicketFail = (error) => {
    return {
        type: actionTypes.GET_TICKET_FAIL,
        error: error
    }
};

export const getTicketSuccess = (data) => {
    return {
        type: actionTypes.GET_TICKET_SUCCESS,
        payload: data
    }
};

export const getActiveTicketsLoading = () => {
    return {
        type: actionTypes.GET_ACTIVE_TICKETS_LOADING
    }
};

export const getActiveTicketsFail = (error) => {
    return {
        type: actionTypes.GET_ACTIVE_TICKETS_FAIL,
        error: error
    }
};

export const getActiveTicketsSuccess = (data) => {
    return {
        type: actionTypes.GET_ACTIVE_TICKETS_SUCCESS,
        payload: data
    }
};

export const setCurrentTicket = (id) => {
    return {
        type: actionTypes.SET_CURRENT_TICKET,
        payload: id
    }
};

export const saveTicketLoading = () => {
    return {
        type: actionTypes.SAVE_CLIENT_LOADING
    }
};

export const saveTicketFail = (error) => {
    return {
        type: actionTypes.SAVE_TICKET_FAIL,
        error: error
    }
};

export const saveTicketSuccess = (data) => {
    return {
        type: actionTypes.SAVE_TICKET_SUCCESS,
        payload: data
    }
};

export const saveTicketInitialize = () => {
    return {
        type: actionTypes.SAVE_TICKET_INITIALIZE
    }
};

export const getTicketDetailsLoading = () => {
    return {
        type: actionTypes.TICKET_DETAILS_LOADING
    }
};

export const getTicketDetailsFail = (error) => {
    return {
        type: actionTypes.TICKET_DETAILS_FAIL,
        error: error
    }
};

export const getTicketDetailsSuccess = (data) => {
    return {
        type: actionTypes.TICKET_DETAILS_SUCCESS,
        payload: data
    }
};

export const addTicketDetailLoading = () => {
    return {
        type: actionTypes.ADD_TICKET_DETAIL_LOADING
    }
};

export const addTicketDetailFail = (error) => {
    return {
        type: actionTypes.ADD_TICKET_DETAIL_FAIL,
        error: error
    }
};

export const addTicketDetailSuccess = (data) => {
    return {
        type: actionTypes.ADD_TICKET_DETAIL_SUCCESS,
        payload: data
    }
};

export const addTicketDetailInitialize = () => {
    return {
        type: actionTypes.ADD_TICKET_DETAIL_INITIALIZE
    }
};

export const initializeAddTicketDetail = () => {
    return dispatch => {
        dispatch(addTicketDetailInitialize());
    }
};

export const initializeSaveTicket = () => {
    return dispatch => {
        dispatch(saveTicketInitialize());
    }
};

export const initializeGetTicket = () => {
    return dispatch => {
        dispatch(getTicketInitialize());
    }
};

export const setTicket = (id) => {
    return dispatch => {
        dispatch(setCurrentTicket(id));
    }
};

export const ticketsList = (token) => {
    return dispatch => {

        dispatch(ticketsLoading());
        axios.get('/api/tickets?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(ticketsSuccess(res.data));
            }).catch(error => {
                let message = "Server error, try again later";
                if (error.response){
                    message = error.response.data.message;
                }
                dispatch(ticketsFail(message));
        });
    }
};

export const ticketsListReseller = (token) => {
    return dispatch => {

        dispatch(ticketsLoading());
        axios.get('/reseller/tickets?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(ticketsSuccess(res.data));
            }).catch(error => {
                let message = "Server error, try again later";
                if (error.response){
                    message = error.response.data.message;
                }
                dispatch(ticketsFail(message));
        });
    }
};

export const ticketsListSuperReseller = (token) => {
    return dispatch => {

        dispatch(ticketsLoading());
        axios.get('/superreseller/tickets?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(ticketsSuccess(res.data));
            }).catch(error => {
                let message = "Server error, try again later";
                if (error.response){
                    message = error.response.data.message;
                }
                dispatch(ticketsFail(message));
        });
    }
};

export const ticketsListAdmin = (token) => {
    return dispatch => {

        dispatch(ticketsLoading());
        axios.get('/admin/tickets?token=' + token)
            .then(res => {
                console.log(res);
                dispatch(ticketsSuccess(res.data));
            }).catch(error => {
                let message = "Server error, try again later";
                if (error.response){
                    message = error.response.data.message;
                }
                dispatch(ticketsFail(message));
        });
    }
};

export const getActiveTicketsAdmin = (token, id) => {
    return dispatch => {
        dispatch(getActiveTicketsLoading());
        axios.get('/admin/activetickets?token=' + token)
            .then(res => {
                dispatch(getActiveTicketsSuccess(res.data))
            }).catch(error => {
            //console.log('logging error getclient: ', error.response.data);
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }

            dispatch(getActiveTicketsFail(message));
        })
    }
};

export const getTicket = (token, id) => {
    return dispatch => {
        dispatch(getTicketLoading());
        axios.get('/api/ticket/' + id + '?token=' + token )
            .then(res => {
                dispatch(getTicketSuccess(res.data))
            }).catch(error => {
            //console.log('logging error getclient: ', error.response.data);
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }

            dispatch(getTicketFail(message));
        })
    }
};

export const getTicketReseller = (token, id) => {
    return dispatch => {
        dispatch(getTicketLoading());
        axios.get('/reseller/ticket/' + id + '?token=' + token )
            .then(res => {
                dispatch(getTicketSuccess(res.data))
            }).catch(error => {
            //console.log('logging error getclient: ', error.response.data);
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }

            dispatch(getTicketFail(message));
        })
    }
};

export const getTicketSuperReseller = (token, id) => {
    return dispatch => {
        dispatch(getTicketLoading());
        axios.get('/superreseller/ticket/' + id + '?token=' + token )
            .then(res => {
                dispatch(getTicketSuccess(res.data))
            }).catch(error => {
            //console.log('logging error getclient: ', error.response.data);
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }

            dispatch(getTicketFail(message));
        })
    }
};

export const getTicketAdmin = (token, id) => {
    return dispatch => {
        dispatch(getTicketLoading());
        axios.get('/admin/ticket/' + id + '?token=' + token )
            .then(res => {
                dispatch(getTicketSuccess(res.data))
            }).catch(error => {
            //console.log('logging error getclient: ', error.response.data);
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }

            dispatch(getTicketFail(message));
        })
    }
};

export const addTicket = (token, data) => {
    return dispatch => {
        dispatch(addTicketLoading());
        axios.post('/api/addticket', {...data, token: token})
            .then(res => {
                dispatch(addTicketSuccess(res.data))
            }).catch(error => {
                //console.log('logging error: ', error.response.data);
                let message = "Server error, try again later";
                if (error.response){
                    message = error.response.data.message;
                    //console.log('error message', message);
                }

                dispatch(addTicketFail(message));
        })
    }
};

export const addTicketReseller = (token, data) => {
    return dispatch => {
        dispatch(addTicketLoading());
        axios.post('/reseller/addticket', {...data, token: token})
            .then(res => {
                dispatch(addTicketSuccess(res.data))
            }).catch(error => {
                //console.log('logging error: ', error.response.data);
                let message = "Server error, try again later";
                if (error.response){
                    message = error.response.data.message;
                    //console.log('error message', message);
                }

                dispatch(addTicketFail(message));
        })
    }
};

export const addTicketSuperReseller = (token, data) => {
    return dispatch => {
        dispatch(addTicketLoading());
        axios.post('/superreseller/addticket', {...data, token: token})
            .then(res => {
                dispatch(addTicketSuccess(res.data))
            }).catch(error => {
                //console.log('logging error: ', error.response.data);
                let message = "Server error, try again later";
                if (error.response){
                    message = error.response.data.message;
                    //console.log('error message', message);
                }

                dispatch(addTicketFail(message));
        })
    }
};

export const saveTicket = (token, data) => {
    return dispatch => {
        dispatch(saveTicketLoading());
        axios.post('/api/saveticket', {...data, token: token})
            .then(res => {
                dispatch(saveTicketSuccess(res.data))
            }).catch(error => {
            //console.log('logging error: ', error.response.data);
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }

            dispatch(saveTicketFail(message));
        })
    }
};

export const saveTicketReseller = (token, data) => {
    return dispatch => {
        dispatch(saveTicketLoading());
        axios.post('/reseller/saveticket', {...data, token: token})
            .then(res => {
                dispatch(saveTicketSuccess(res.data))
            }).catch(error => {
            //console.log('logging error: ', error.response.data);
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }

            dispatch(saveTicketFail(message));
        })
    }
};

export const saveTicketSuperReseller = (token, data) => {
    return dispatch => {
        dispatch(saveTicketLoading());
        axios.post('/superreseller/saveticket', {...data, token: token})
            .then(res => {
                dispatch(saveTicketSuccess(res.data))
            }).catch(error => {
            //console.log('logging error: ', error.response.data);
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }

            dispatch(saveTicketFail(message));
        })
    }
};

export const saveTicketAdmin = (token, data) => {
    return dispatch => {
        dispatch(saveTicketLoading());
        axios.post('/admin/saveticket', {...data, token: token})
            .then(res => {
                dispatch(saveTicketSuccess(res.data))
            }).catch(error => {
            //console.log('logging error: ', error.response.data);
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }

            dispatch(saveTicketFail(message));
        })
    }
};

export const getTicketDetails = (token, id) => {
    return dispatch => {
        dispatch(getTicketDetailsLoading());
        axios.get('/api/ticketdetails/' + id + '?token=' + token )
            .then(res => {
                dispatch(getTicketDetailsSuccess(res.data))
            }).catch(error => {
            //console.log('logging error: ', error.response.data);
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(getTicketDetailsFail(message));
        })
    }
};

export const getTicketDetailsReseller = (token, id) => {
    return dispatch => {
        dispatch(getTicketDetailsLoading());
        axios.get('/reseller/ticketdetails/' + id + '?token=' + token )
            .then(res => {
                dispatch(getTicketDetailsSuccess(res.data))
            }).catch(error => {
            //console.log('logging error: ', error.response.data);
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(getTicketDetailsFail(message));
        })
    }
};

export const getTicketDetailsSuperReseller = (token, id) => {
    return dispatch => {
        dispatch(getTicketDetailsLoading());
        axios.get('/superreseller/ticketdetails/' + id + '?token=' + token )
            .then(res => {
                dispatch(getTicketDetailsSuccess(res.data))
            }).catch(error => {
            //console.log('logging error: ', error.response.data);
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(getTicketDetailsFail(message));
        })
    }
};

export const getTicketDetailsAdmin = (token, id) => {
    return dispatch => {
        dispatch(getTicketDetailsLoading());
        axios.get('/admin/ticketdetails/' + id + '?token=' + token )
            .then(res => {
                dispatch(getTicketDetailsSuccess(res.data))
            }).catch(error => {
            //console.log('logging error: ', error.response.data);
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(getTicketDetailsFail(message));
        })
    }
};

export const addTicketDetail = (token, data) => {
    return dispatch => {
        dispatch(addTicketDetailLoading());
        axios.post('/api/addticketdetail', {...data, token: token})
            .then(res => {
                dispatch(addTicketDetailSuccess(res.data))
            }).catch(error => {
            //console.log('logging error: ', error.response.data);
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(addTicketDetailFail(message));
        })
    }
};

export const addTicketDetailReseller = (token, data) => {
    return dispatch => {
        dispatch(addTicketDetailLoading());
        axios.post('/reseller/addticketdetail', {...data, token: token})
            .then(res => {
                dispatch(addTicketDetailSuccess(res.data))
            }).catch(error => {
            //console.log('logging error: ', error.response.data);
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(addTicketDetailFail(message));
        })
    }
};

export const addTicketDetailSuperReseller = (token, data) => {
    return dispatch => {
        dispatch(addTicketDetailLoading());
        axios.post('/superreseller/addticketdetail', {...data, token: token})
            .then(res => {
                dispatch(addTicketDetailSuccess(res.data))
            }).catch(error => {
            //console.log('logging error: ', error.response.data);
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(addTicketDetailFail(message));
        })
    }
};

export const addTicketDetailAdmin = (token, data) => {
    return dispatch => {
        dispatch(addTicketDetailLoading());
        axios.post('/admin/addticketdetail', {...data, token: token})
            .then(res => {
                dispatch(addTicketDetailSuccess(res.data))
            }).catch(error => {
            //console.log('logging error: ', error.response.data);
            let message = "Server error, try again later";
            if (error.response){
                message = error.response.data.message;
            }
            dispatch(addTicketDetailFail(message));
        })
    }
};
